<template>
  <Dialog
      id="school-module-modal"
      v-model:visible="visible"
      :header="t('ALLOW_MODULES')"
      modal
      class="school-module-modal"
      :draggable="false"
      :dismissable-mask="true"
  >
    <div class="row">
      <div class="col">
        <ul class="school-module-list">
          <li v-for="training in trainings" :key="training.id" class="flex align-items-center mb-2">
            <Checkbox
                :input-id="'training-' + training.id"
                :model-value="selectedTrainings.includes(training.id)"
                :binary="true"
                @update:model-value="(v) => toggleTraining(training.id, v)"
            />
            <label :for="'training-' + training.id" class="ms-2 label">
              {{ training.code }} {{ training.name }}
            </label>
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <Button :label="t('CONFIRM')" @click="addModules"/>
    </template>
  </Dialog>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import EventBus from "@/util/eventBus";
import {useToast} from "@/util/toastUtils";

const axios = injectAxios();
const props = defineProps({
  trainings: Array,
});
const emit = defineEmits(["update-complete"]);
const {t} = useI18n();
const route = useRoute();
const toast = useToast();

const visible = ref(false);
const selectedTrainings = ref([]);

function toggleTraining(id, checked) {
  if (checked) {
    if (!selectedTrainings.value.includes(id)) {
      selectedTrainings.value = [...selectedTrainings.value, id];
    }
  } else {
    selectedTrainings.value = selectedTrainings.value.filter((x) => x !== id);
  }
}

onMounted(() => {
  EventBus.$on("show-school-module-modal", () => {
    visible.value = true;
  });
});

onBeforeUnmount(() => {
  EventBus.$off("show-school-module-modal");
});

async function addModules() {
  await axios.post(`/school/${route.params.id}/add-module`, selectedTrainings.value);
  toast.makeSuccessToast(t("ADDED_MODULE"));
  emit("update-complete", true);
  visible.value = false;
}
</script>

<style scoped>
.school-module-list {
  list-style-type: none;
  padding-left: 0;
}

.label {
  margin-left: 0.5rem;
}
</style>
